import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/announcementBarApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import SaleAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/SaleAnTemplateWidget";
import NewProductAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/NewProductAnTemplateWidget";
import NewStoreAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/NewStoreAnTemplateWidget";
import FreeShippingAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/FreeShippingAnTemplateWidget";
import NewsAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/NewsAnTemplateWidget";
import UpdateAnTemplateWidget from "../../../../components/Apps/AnnouncementBar/Template/UpdateAnTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/AnnouncementBar/ContentTab";
import PositionTab from "../../../../components/Apps/AnnouncementBar/PositionTab";
import StyleTab from "../../../../components/Apps/AnnouncementBar/StyleTab";
import SettingTab from "../../../../components/Apps/AnnouncementBar/SettingTab";

export default function EditPhotoGallery() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Sale_Announcement_Temp");
    const [selectedLayout, setSelectedLayout] = useState("sale_announcement_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("sale-announcement.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Announcement Bar");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);

    const [announcementBarTabData, setAnnouncementBarTabData] = useState({
        is_website_frontend: "",  
        message: "",  
        action_element_type: "Button",  
        action_element_button_text: "",  
        action_element_button_link: "",  
        visual_element_type: "Badge",  
        visual_element_badge_text: "",  
        is_close_button: 1,  
        bar_link: "",  
        message_on_mobile: "",  
        postion_type: "",  
        bar_size_type: "Medium",  
        font_type: "Default",  
        background_color: "",  
        message_color: "",  
        badge_color: "",  
        button_color: "",  
        bar_mobile_size_type: "Medium",    
        display_page_type: "All_Pages",    
        hide_page_type: "None",    
        visibility_on_devices: "All Devices",    
        is_bar_display_schedule : 1,    
        is_visitor_closed_bar : 1,    
        is_visitor_clicked_bar  : 1,    
        custom_css: "",   
        custom_js: "",   
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateAnnouncementBarTabData = (key, value) => {
        setAnnouncementBarTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Position", icon: "position.png", label: "Position" },
        { key: "Style", icon: "style.png", label: "Style" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setAnnouncementBarTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid],setAnnouncementBarTabData);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(announcementBarTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/announcement-bar');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/announcement-bar/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Content" && (
                        <ContentTab updateAnnouncementBarTabData={updateAnnouncementBarTabData} announcementBarTabData={announcementBarTabData} />
                    )}
                    {activeSection === "Position" && (
                        <PositionTab updateAnnouncementBarTabData={updateAnnouncementBarTabData} announcementBarTabData={announcementBarTabData} />
                    )}
                    {activeSection === "Style" && (
                        <StyleTab updateAnnouncementBarTabData={updateAnnouncementBarTabData} announcementBarTabData={announcementBarTabData}/>
                    )}
                    {activeSection === "Settings" && (
                        <SettingTab updateAnnouncementBarTabData={updateAnnouncementBarTabData} announcementBarTabData={announcementBarTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/announcement-bar"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/announcement-bar/announcement-bar.svg`} alt="announcement-bar"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/announcement-bar/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/announcement-bar" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Announcement Bar <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Sale_Announcement_Temp" && (
                      <SaleAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "New_Product_Announcement_Temp" && (
                      <NewProductAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "New_Store_Announcement_Temp" && (
                      <NewStoreAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "Free_Shipping_Announcement_Temp" && (
                      <FreeShippingAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "News_Announcement_Temp" && (
                      <NewsAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}

                    {activeTemplateSection === "Update_Announcement_Temp" && (
                      <UpdateAnTemplateWidget announcementBarTabData={announcementBarTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 